import './colorSchemeMenu.css';

import React, {Component} from 'react';
import Button from './Button';
import DarkMode from '../icon/DarkMode';
import LightMode from '../icon/LightMode';
import SystemMode from '../icon/SystemMode';
import {kThemeDark, kThemeLight, kThemeSystem} from '../service/Theme';

/**
 * System comes first and is the default, same as the theme menus in the other projects.
 * The label is the English source string, which is also the key the server returns its translation under.
 */
const colorSchemeMenuItems = [
	{value: kThemeSystem, label: 'System', icon: <SystemMode/>},
	{value: kThemeDark, label: 'Dark', icon: <DarkMode/>},
	{value: kThemeLight, label: 'Light', icon: <LightMode/>}
];

class ColorSchemeMenu extends Component {
	/**
	 * ColorSchemeMenu initialization.
	 */
	constructor (props) {
		super (props);

		this.container = React.createRef ();

		this.state = {
			open: false
		};

		this.OnDocumentClick = this.OnDocumentClick.bind (this);
		this.OnDocumentKeyDown = this.OnDocumentKeyDown.bind (this);
	}

	/**
	 * Component was updated, follow the open state with the document listeners.
	 */
	componentDidUpdate (prevProps, prevState) {
		const {open: prevOpen} = prevState;
		const {open} = this.state;

		if (prevOpen === open) {
			return;
		}

		if (open) {
			document.addEventListener ('click', this.OnDocumentClick);
			document.addEventListener ('keydown', this.OnDocumentKeyDown);
		} else {
			this.RemoveDocumentListeners ();
		}
	}

	/**
	 * Called before component is removed from DOM.
	 */
	componentWillUnmount () {
		this.RemoveDocumentListeners ();
	}

	/**
	 * Render the component into html.
	 */
	render () {
		const {labels, selectedTheme} = this.props;
		const {open} = this.state;

		const selectedItem = colorSchemeMenuItems.find (element => element.value === selectedTheme);

		return <div className="color-scheme-menu" ref={this.container}>
			<Button className="button icon color-scheme-menu-trigger" title={labels [selectedItem.label]}
			        aria-haspopup="true" aria-expanded={open} aria-label={labels [selectedItem.label]}
			        onClick={this.Toggle.bind (this)}>
				{selectedItem.icon}
			</Button>

			<div className={`color-scheme-menu-dropdown ${open ? 'open' : ''}`} role="menu">
				{colorSchemeMenuItems.map (element => <Button key={element.value} role="menuitem"
				                                              className={`button color-scheme-menu-item ${element.value === selectedTheme ? 'selected' : ''}`}
				                                              onClick={() => this.Choose (element.value)}>
					{element.icon}
					<span>{labels [element.label]}</span>
				</Button>)}
			</div>
		</div>;
	}

	/**
	 * Toggle the dropdown.
	 */
	Toggle () {
		const {open} = this.state;

		this.setState ({open: !open});
	}

	/**
	 * Choose a preference and close the dropdown.
	 */
	Choose (theme) {
		const {onChangeTheme} = this.props;

		this.setState ({open: false});

		onChangeTheme (theme);
	}

	/**
	 * Close when the click landed outside the menu.
	 */
	OnDocumentClick (e) {
		if (this.container.current.contains (e.target)) {
			return;
		}

		this.setState ({open: false});
	}

	/**
	 * Close on Escape.
	 */
	OnDocumentKeyDown (e) {
		if (e.key !== 'Escape') {
			return;
		}

		this.setState ({open: false});
	}

	/**
	 * Remove the document listeners the open dropdown installed.
	 */
	RemoveDocumentListeners () {
		document.removeEventListener ('click', this.OnDocumentClick);
		document.removeEventListener ('keydown', this.OnDocumentKeyDown);
	}
}

export default ColorSchemeMenu;
